import { usePost } from "../utilities/react-query";
import request from "./request";

export interface PasswordResetRequestPayload {
  email: string;
}

export interface PasswordResetValidatePayload {
  uid: string;
  token: string;
}

export interface PasswordResetConfirmPayload {
  uid: string;
  token: string;
  new_password: string;
  confirm_password: string;
}

export const requestPasswordResetApi = async (data: PasswordResetRequestPayload) => {
  const response = await request.post("/auth/password-reset/", data);
  return response.data;
};

export const validateResetTokenApi = async (data: PasswordResetValidatePayload) => {
  const response = await request.post("/auth/password-reset/validate/", data);
  return response.data;
};

export const confirmPasswordResetApi = async (data: PasswordResetConfirmPayload) => {
  const response = await request.post("/auth/password-reset/confirm/", data);
  return response.data;
};

export const useRequestPasswordReset = (updater?: any) => {
  const response = usePost<any, any>("/auth/password-reset/", undefined, undefined, updater);
  return {
    ...response,
  };
};

export const useValidateResetToken = (updater?: any) => {
  const response = usePost<any, any>("/auth/password-reset/validate/", undefined, undefined, updater);
  return {
    ...response,
  };
};

export const useConfirmPasswordReset = (updater?: any) => {
  const response = usePost<any, any>("/auth/password-reset/confirm/", undefined, undefined, updater);
  return {
    ...response,
  };
};
